import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["branchSelect", "serviceSelect", "serviceSelectWrapper"]
  static values = { url: String }

  branchChanged() {
    const branchId = this.branchSelectTarget.value
    if (!branchId) {
      this.serviceSelectWrapperTarget.classList.add("hidden")
      return
    }

    fetch(`${this.urlValue}?source_branch_id=${branchId}`, {
      headers: { "Accept": "application/json" }
    })
      .then(response => response.json())
      .then(services => {
        this.serviceSelectTarget.innerHTML = `<option value="">${this.serviceSelectTarget.dataset.placeholder}</option>`
        services.forEach(service => {
          const option = document.createElement("option")
          option.value = JSON.stringify(service)
          option.textContent = service.name
          this.serviceSelectTarget.appendChild(option)
        })
        this.serviceSelectWrapperTarget.classList.remove("hidden")
      })
  }

  serviceChanged() {
    const value = this.serviceSelectTarget.value
    if (!value) return

    const service = JSON.parse(value)
    const form = this.element.closest(".container").querySelector("form")

    this._setField(form, "service[name]", service.name)
    this._setField(form, "service[duration]", service.duration)
    this._setField(form, "service[break_time]", service.break_time)
    this._setField(form, "service[price]", service.price)
    this._setField(form, "service[price_max]", service.price_max || "")
    this._setField(form, "service[deposit_amount]", service.deposit_amount || "")
    this._setField(form, "service[maximum_users_per_slot]", service.maximum_users_per_slot)

    // Set service group name in the combobox input and clear the hidden ID
    const groupInput = form.querySelector("[data-combobox-target='input']")
    if (groupInput) {
      groupInput.value = service.service_group_name || ""
    }
    const groupHiddenId = form.querySelector("[data-combobox-target='hiddenId']")
    if (groupHiddenId) {
      groupHiddenId.value = ""
    }

    // Copy add-ons
    const addonsController = this.application.getControllerForElementAndIdentifier(
      form.querySelector("[data-controller='service-addons']"),
      "service-addons"
    )
    if (addonsController && service.service_addons) {
      // Remove existing addon entries
      addonsController.entryTargets.forEach(entry => entry.remove())

      // Add copied addons
      service.service_addons.forEach(addon => {
        addonsController.add()
        const entries = addonsController.entryTargets
        const lastEntry = entries[entries.length - 1]
        const inputs = lastEntry.querySelectorAll("input")
        inputs.forEach(input => {
          if (input.name.includes("[name]")) input.value = addon.name
          if (input.name.includes("[price]") && !input.name.includes("price_max")) input.value = addon.price
          if (input.name.includes("[price_max]")) input.value = addon.price_max || ""
          if (input.name.includes("[duration]")) input.value = addon.duration
          if (input.name.includes("[addon_id]")) input.value = addon.addon_id || ""
        })
      })
    }
  }

  _setField(form, name, value) {
    const field = form.querySelector(`[name="${name}"]`)
    if (field) field.value = value
  }
}
